<div *ngIf="openIdProfile">
    <div class="create">
        <button
            class="btn btn-sm btn-primary"
            [routerLink]="['/subscriptions-plans', 0]"
        >
            <i class="bi bi-plus"></i>
        </button>
    </div>

    <table mat-table [dataSource]="planModels" class="table-list">
        <ng-container matColumnDef="control">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let planModel">
                <div class="btn-group">
                    <button
                        [disabled]="planModel.subscriber_count > 0"
                        [routerLink]="['/subscriptions-plans', planModel.id]"
                        class="btn btn-sm btn-success"
                    >
                        <i class="bi bi-pencil"></i>
                    </button>

                    <button
                        [disabled]="planModel.subscriber_count > 0"
                        class="btn btn-sm btn-danger"
                        (click)="confirmDelete(planModel)"
                    >
                        <i class="bi bi-trash2"></i>
                    </button>

                    <button
                        *ngIf="planModel.enabled"
                        class="btn btn-sm btn-info enable-control"
                        title="Disable"
                        (click)="toggleEnabled(planModel)"
                    >
                        <i class="bi bi-stop-fill"></i>
                    </button>

                    <button
                        *ngIf="!planModel.enabled"
                        class="btn btn-sm btn-info enable-control"
                        title="Enable"
                        (click)="toggleEnabled(planModel)"
                    >
                        <i class="bi bi-play-fill"></i>
                    </button>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let planModel">
                {{ planModel.id }}
            </td>
        </ng-container>

        <ng-container matColumnDef="tiers">
            <th mat-header-cell *matHeaderCellDef>Tiers</th>
            <td mat-cell *matCellDef="let planModel">
                <button
                    class="btn btn-sm btn-info"
                    routerLink="/subscriptions-plans/{{ planModel.id }}/tiers"
                >
                    {{ planModel.tier_count }}
                </button>
            </td>
        </ng-container>

        <ng-container matColumnDef="enabled">
            <th mat-header-cell *matHeaderCellDef>Enabled</th>
            <td mat-cell *matCellDef="let planModel">
                {{ planModel.enabled ? "Yes" : "No" }}
            </td>
        </ng-container>

        <ng-container matColumnDef="owner">
            <th mat-header-cell *matHeaderCellDef>Owner</th>
            <td mat-cell *matCellDef="let planModel">
                {{ planModel.receiver_email }}
            </td>
        </ng-container>

        <ng-container matColumnDef="subscriber_count">
            <th mat-header-cell *matHeaderCellDef>
                Subscribers
                <div><small>Active / Total</small></div>
            </th>
            <td mat-cell *matCellDef="let planModel">
                {{ planModel.subscriber_count_active }} /
                {{ planModel.subscriber_count }}
            </td>
        </ng-container>

        <ng-container matColumnDef="secret_key">
            <th mat-header-cell *matHeaderCellDef>Key</th>
            <td mat-cell *matCellDef="let planModel">
                <app-component-clipboard
                    [data]="openIdProfile.id"
                ></app-component-clipboard>
            </td>
        </ng-container>

        <ng-container matColumnDef="secret_token">
            <th mat-header-cell *matHeaderCellDef>Token</th>
            <td mat-cell *matCellDef="let planModel">
                <app-component-clipboard
                    data="'Token'"
                ></app-component-clipboard>
            </td>
        </ng-container>

        <ng-container matColumnDef="label">
            <th mat-header-cell *matHeaderCellDef>Label</th>
            <td mat-cell *matCellDef="let planModel">
                {{ planModel.label }}
            </td>
        </ng-container>

        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let planModel">
                {{ planModel.description }}
            </td>
        </ng-container>

        <ng-container matColumnDef="webhook">
            <th mat-header-cell *matHeaderCellDef>Webhook</th>
            <td mat-cell *matCellDef="let planModel">
                <span *ngIf="planModel.webhook">{{ planModel.webhook }}</span>
                <span *ngIf="!planModel.webhook">No</span>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnHeadings"></tr>
        <tr mat-row *matRowDef="let row; columns: columnHeadings"></tr>
    </table>
</div>

<div>
    <mat-paginator
        [length]="pagingItemCount"
        [pageSize]="pagingPageSize"
        showFirstLastButtons
    >
    </mat-paginator>
</div>

<div class="card" *ngIf="openIdProfile">
    <div class="card-header">Third Party Configuration</div>
    <div class="card-body">
        <div>
            <label>Secret</label>
            {{ openIdProfile.id }}
            <app-component-clipboard
                [data]="openIdProfile.id"
            ></app-component-clipboard>
        </div>
        <div *ngIf="token">
            <label>Token</label>
            {{ token }}
            <app-component-clipboard [data]="token"></app-component-clipboard>
        </div>
        <div>
            <label>Webhook for Acc</label>
            http(s)://DOMAIN/service/ecommerce/provider/barter
        </div>
    </div>
</div>
